import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const TaskFilters = ({ filters, onFilterChange, tasks }) => {
  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const clearFilters = () => {
    onFilterChange({ status: "", priority: "", category: "" });
  };

  const categories = [...new Set(tasks.map((task) => task.category).filter(Boolean))];
  const hasActiveFilters = filters.status || filters.priority || filters.category;

  return (
    <div
      className="bg-gray-50 rounded-lg p-4 border border-gray-200 mt-4"
      data-testid="task-filters"
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Filters</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={clearFilters}
            data-testid="clear-filters-button"
            className="text-xs"
          >
            Clear All
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-700">Status</label>
          <Select
            value={filters.status}
            onValueChange={(value) => handleFilterChange("status", value)}
          >
            <SelectTrigger data-testid="filter-status-select">
              <SelectValue placeholder="All statuses" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all" data-testid="filter-status-all">
                All statuses
              </SelectItem>
              <SelectItem value="To Do" data-testid="filter-status-todo">
                To Do
              </SelectItem>
              <SelectItem value="In Progress" data-testid="filter-status-in-progress">
                In Progress
              </SelectItem>
              <SelectItem value="Done" data-testid="filter-status-done">
                Done
              </SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-700">Priority</label>
          <Select
            value={filters.priority}
            onValueChange={(value) => handleFilterChange("priority", value)}
          >
            <SelectTrigger data-testid="filter-priority-select">
              <SelectValue placeholder="All priorities" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all" data-testid="filter-priority-all">
                All priorities
              </SelectItem>
              <SelectItem value="High" data-testid="filter-priority-high">
                High
              </SelectItem>
              <SelectItem value="Medium" data-testid="filter-priority-medium">
                Medium
              </SelectItem>
              <SelectItem value="Low" data-testid="filter-priority-low">
                Low
              </SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-700">Category</label>
          <Select
            value={filters.category}
            onValueChange={(value) => handleFilterChange("category", value)}
          >
            <SelectTrigger data-testid="filter-category-select">
              <SelectValue placeholder="All categories" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all" data-testid="filter-category-all">
                All categories
              </SelectItem>
              {categories.map((cat) => (
                <SelectItem
                  key={cat}
                  value={cat}
                  data-testid={`filter-category-${cat.toLowerCase()}`}
                >
                  {cat}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default TaskFilters;
